import _noop from "lodash/noop";
import _merge from "lodash/merge";

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Popover } from '@nextiva/next-ui';
import { ORDER_ASCENDING, ORDER_DESCENDING } from "../constants";
import TypeFilter from "./columns/TypeFilter";

var FilterSort =
/*#__PURE__*/
function (_Component) {
  _inherits(FilterSort, _Component);

  function FilterSort(props) {
    var _this;

    _classCallCheck(this, FilterSort);

    _this = _possibleConstructorReturn(this, (FilterSort.__proto__ || Object.getPrototypeOf(FilterSort)).call(this, props));
    Object.defineProperty(_assertThisInitialized(_this), "togglePopover", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value(event) {
        var showPopover = _this.state.showPopover;
        event.stopPropagation();

        _this.props.onToggleFilter(!showPopover);

        _this.setState({
          showPopover: !showPopover
        });
      }
    });
    Object.defineProperty(_assertThisInitialized(_this), "renderFilter", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value() {
        var filterClassNames = cx('nx-table__filter', 'icon-custom-filter', {
          active: _this.props.isActive
        });
        return React.createElement("i", {
          onClick: _this.togglePopover,
          className: filterClassNames,
          "data-html2canvas-ignore": true
        });
      }
    });
    Object.defineProperty(_assertThisInitialized(_this), "handleSortClick", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value() {
        var order = _this.props.order;
        var nextOrder = order === undefined || order === ORDER_ASCENDING ? ORDER_DESCENDING : ORDER_ASCENDING;

        _this.props.onSortChange(nextOrder);
      }
    });
    Object.defineProperty(_assertThisInitialized(_this), "getFilterComponent", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props = _this.props,
            title = _this$props.title,
            filterData = _this$props.filterData,
            type = _this$props.type,
            onResetAll = _this$props.onResetAll,
            options = _this$props.options,
            loadOptions = _this$props.loadOptions,
            typeConfig = _this$props.typeConfig,
            columnData = _this$props.columnData,
            onFilterChange = _this$props.onFilterChange;
        var columnDataOptions = columnData && columnData.options;
        return React.createElement(TypeFilter, {
          type: type,
          typeConfig: typeConfig,
          title: title,
          options: options,
          loadOptions: loadOptions,
          filterData: filterData,
          onClose: _this.togglePopover,
          onFiltersChange: onFilterChange,
          onResetAll: onResetAll,
          columnDataOptions: columnDataOptions
        });
      }
    });
    _this.state = {
      showPopover: false
    };
    return _this;
  }

  _createClass(FilterSort, [{
    key: "renderSort",
    value: function renderSort() {
      var _props = this.props,
          order = _props.order,
          analytics = _props.analytics;
      var sortClassNames = cx('nx-table__sort', {
        'icon-custom-caret-open-down': order === ORDER_ASCENDING || order === undefined
      }, {
        'icon-custom-caret-close-up': order === ORDER_DESCENDING
      }, {
        active: order !== undefined
      });

      if (analytics && order === undefined) {
        return React.createElement("span", {
          className: "nx-table__header-filter-sort-container",
          "data-html2canvas-ignore": true
        }, React.createElement("i", {
          onClick: this.handleSortClick,
          className: "icon-custom-caret-close-up"
        }), React.createElement("i", {
          onClick: this.handleSortClick,
          className: "icon-custom-caret-open-down"
        }));
      }

      return React.createElement("i", {
        onClick: this.handleSortClick,
        className: sortClassNames,
        "data-html2canvas-ignore": true
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _props2 = this.props,
          className = _props2.className,
          children = _props2.children,
          shouldRenderFilter = _props2.shouldRenderFilter,
          shouldRenderSort = _props2.shouldRenderSort,
          _props2$config = _props2.config;
      _props2$config = _props2$config === void 0 ? {} : _props2$config;
      var _props2$config$popove = _props2$config.popover,
          popover = _props2$config$popove === void 0 ? {} : _props2$config$popove;

      var popper = _merge({
        modifiers: {
          offset: {
            offset: '0, 10'
          },
          preventOverflow: {
            padding: 16
          }
        }
      }, popover);

      var ChildFilter = this.getFilterComponent();
      var Child = shouldRenderFilter ? React.cloneElement(React.Children.only(children), {
        onClick: this.togglePopover,
        clickable: 'true'
      }) : children;
      return React.createElement("div", {
        className: "nx-table__header-filter-wrapper"
      }, Child, React.createElement("span", {
        className: className
      }, shouldRenderFilter && React.createElement(Popover, {
        bodyClassName: "nx-table-popover nx-table-filter-popover",
        body: ChildFilter,
        isOpen: this.state.showPopover,
        popper: popper // for prevent invocation of onClickOutside from Popover2 component
        ,
        onClickOutside: function onClickOutside() {}
      }, this.renderFilter()), shouldRenderSort && this.renderSort()));
    }
  }]);

  return FilterSort;
}(Component);

Object.defineProperty(FilterSort, "propTypes", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: {
    /**
     * Options to supply to MultiSelect component
     */
    order: PropTypes.oneOf([ORDER_ASCENDING, ORDER_DESCENDING]),
    onResetAll: PropTypes.func,

    /**
     * Called after user selected the desired filters
     */
    onFilterChange: PropTypes.func,

    /**
     * Called after user selected ordering
     */
    onSortChange: PropTypes.func,
    filterData: PropTypes.object,
    columnData: PropTypes.object,
    options: PropTypes.array,
    loadOptions: PropTypes.func,
    isActive: PropTypes.bool,
    shouldRenderFilter: PropTypes.bool,
    shouldRenderSort: PropTypes.bool,
    analytics: PropTypes.bool,
    onToggleFilter: PropTypes.func
  }
});
Object.defineProperty(FilterSort, "defaultProps", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: {
    onFilterChange: _noop,
    onSortChange: _noop,
    onToggleFilter: _noop,
    options: [],
    columnData: {},
    isActive: false,
    shouldRenderFilter: true,
    shouldRenderSort: true,
    analytics: false
  }
});
export default FilterSort;